import Footer from '@/components/layout/footer';
import { NavbarCleaner } from '@/components/layout/navbar/navbar.cleaner';
import { FAQ } from '@/features/consumer/faq';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(cleaner)/cleaner/faq')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div>
      <NavbarCleaner />
      <FAQ />
      <Footer />
    </div>
  );
}
